// @flow
import React from 'react';
import { Typography } from "src/latest/src/components";
import Input from '../Input/Input';
import checkIcon from './../../../../../assets/icons/icon-checkmark.svg';
import './MiniCheckBox.scss';

type Props = {
    className?: string,
    onClick: Function,
    text: string,
    hasOther?:boolean,
    inputValue?: string,
    props?: Object,
    selected?:Boolean,
    id:string,
    onChange:Function
}

export default function MiniCheckBox({ className = '', onChange, onClick, id, text, selected = false,  hasOther, inputValue, ...props }: Props): React$Element<any> {
    const onCheckboxClick = (e:Event) => {
        if (e.target.nodeName !== 'INPUT')onClick(!selected, id);
    };

    const onValueChange = (e:Event) => {
        onChange(e.target.value, id);
    };

    return (
        <div className={`mini-check-box  ${className}`} onClick={onCheckboxClick}>
            <div className={`mini-check-box__container ${hasOther && selected ? !inputValue ? '-error-bordered-mini':'-bordered-mini': ''}`}>
                {
                    <React.Fragment>
                        <span className={'mini-check-box__check cursor-pointer' + (selected ? ' checked' : '')}>
                            {
                                <img src={checkIcon} alt='check'/>
                            }
                        </span>
                        {
                            (!hasOther || !selected) && <Typography className='check-title cursor-pointer' variant='size-14'
                                color={'color-2'}
                                weight='regular'>
                                {text}
                            </Typography>
                        }
                        {
                            hasOther && selected && <Input {...props} className='mb-0'
                                checkbox={true}
                                value={inputValue}
                                autoFocus={true}
                                onChange={onValueChange}
                                placeholder={text}/>
                        }
                    </React.Fragment>
                }
            </div>
        </div>
    );
}
